<template>
  <div>
    <Breadcrumbs title="Match"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      match: this.$route.params.match,
    }
  },
  computed: {
    title: function () { return 'Matching '+this.match+'...' }
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } },
    '$route.params.match': function (val) { this.match = val }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {

    },
    findMatch() {

    }
  }
}
</script>